import { useLocation } from "react-router-dom";

import { useIsDesktopApp } from "./MVVM/Hooks/useIsDesktopApp";
import { useIsMobileApp } from "./MVVM/Hooks/useIsMobileApp";

import { Sidebar } from "./MVVM/Components/Sidebar";
import { NavSignup } from "./components/organisms/navSignup";
import { MINIMAL_ROUTES } from "./routes/utils";
import { pathExcludesNavigation } from "./MVVM/Utilities/Navigation/utils";

const Navigation = () => {
  const { pathname } = useLocation();
  const isDesktopView = useIsDesktopApp();
  const isMobileApp = useIsMobileApp();

  if (
    pathExcludesNavigation(pathname) ||
    isDesktopView.isDesktop ||
    isMobileApp.isMobileApp ||
    pathname.includes("mobile-app-link")
  )
    return <></>;

  if (MINIMAL_ROUTES.includes(pathname)) return <NavSignup />;

  return <Sidebar />;
};

export { Navigation };
